/* @flow */

import * as React from 'react';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import Localizer from '../../helpers/localization';
import { Messenger, MessengerEvents } from '../../helpers/messenger';
import ProfilesManager from '../../helpers/profiles/profilesManager';
import { RegistrationType } from '../../redux/appRegistration/types/types';
import ButtonFX from '../buttons/ButtonFX';
import { HeightKind, WidthKind } from '../buttons/types';
import { PictoUser } from '../pictos/Element';
import Avatar from '../profiles/Avatar';
import { AvatarSize } from '../profiles/types';
import './UserMenu.css';

const UserMenu = (): React.Node => {
  const isRegisteredAsGuest = useSelector((state) => state.appRegistration.registration === RegistrationType.RegisteredAsGuest);

  const handleGlobalSettingsOnClick = useCallback(() => Messenger.emit(MessengerEvents.OPEN_GLOBAL_SETTINGS), []);

  // Guest mode: let's open the sign-in page
  const handleSignInOnClick = useCallback(() => Messenger.emit(MessengerEvents.SHOW_SIGN_IN), []);

  if (isRegisteredAsGuest) {
    // Sign-in button
    return (
      <ButtonFX hasPadding heightKind={HeightKind.Medium} onClick={handleSignInOnClick} widthKind={WidthKind.Content}>
        {Localizer.localize('authentication.connection')}
      </ButtonFX>
    );
  }

  const currentProfile = ProfilesManager.getCurrentProfile();
  if (currentProfile === null) {
    // Generic user picto icon
    return <PictoUser aria-label={Localizer.localize('accessibility.navigation.user_menu')} onClick={handleGlobalSettingsOnClick} />;
  }

  // User profile avatar
  const { avatarId, id, name } = currentProfile;
  return <Avatar aria-label={Localizer.localize('accessibility.navigation.user_menu')} avatarId={avatarId} name={name} onClick={handleGlobalSettingsOnClick} profileId={id} size={AvatarSize.Small} />;
};

export default UserMenu;
